(function () {
  'use strict';

  const selectors = {
    mobileMenu: '[data-mobile-menu]',
    mobileMenuToggle: '[data-mobile-menu-toggle]',
    mobileMenuClose: '[data-mobile-menu-close]',
    faqItem: '[data-faq-item]',
    faqQuestion: '[data-faq-question]',
    productGallery: '[data-product-gallery]',
    productThumb: '[data-product-thumb]',
    productMainImage: '[data-product-main-image]',
    zoomModal: '[data-zoom-modal]',
    zoomImage: '[data-zoom-image]',
    stickyAtc: '[data-sticky-atc]',
    productForm: '[data-product-form]',
    quantityInput: '[data-quantity-input]',
    quantityMinus: '[data-quantity-minus]',
    quantityPlus: '[data-quantity-plus]',
    quickAddForm: '[data-quick-add-form]',
    cartDrawer: '[data-cart-drawer]',
    cartToggle: '[data-cart-toggle]',
    cartClose: '[data-cart-close]',
    cartItems: '[data-cart-items]',
    cartCount: '[data-cart-count]',
    cartSubtotal: '[data-cart-subtotal]',
    productTabs: '[data-product-tabs]',
    productTabBtn: '[data-product-tab]',
    productTabPanel: '[data-product-tab-panel]',
    variantOption: '[data-variant-option]',
    collectionSort: '[data-collection-sort]'
  };

  /* Mobile menu */
  function initMobileMenu() {
    const menu = document.querySelector(selectors.mobileMenu);
    const toggle = document.querySelector(selectors.mobileMenuToggle);
    const close = document.querySelector(selectors.mobileMenuClose);
    if (!menu || !toggle) return;

    const open = () => {
      menu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    };
    const shut = () => {
      menu.classList.remove('is-open');
      document.body.style.overflow = '';
    };

    toggle.addEventListener('click', open);
    close?.addEventListener('click', shut);
    menu.querySelector('.mobile-menu__overlay')?.addEventListener('click', shut);
  }

  /* FAQ accordion */
  function initFaq() {
    document.querySelectorAll(selectors.faqQuestion).forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = btn.closest(selectors.faqItem);
        const isOpen = item.classList.contains('is-open');
        item.closest('.faq-list')?.querySelectorAll(selectors.faqItem).forEach((el) => {
          el.classList.remove('is-open');
          el.querySelector(selectors.faqQuestion)?.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* Product gallery */
  function initProductGallery() {
    const gallery = document.querySelector(selectors.productGallery);
    if (!gallery) return;

    const mainImage = gallery.querySelector(selectors.productMainImage);
    const thumbs = gallery.querySelectorAll(selectors.productThumb);
    const zoomModal = document.querySelector(selectors.zoomModal);
    const zoomImage = document.querySelector(selectors.zoomImage);

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.fullSrc || thumb.querySelector('img')?.src;
        if (src && mainImage) {
          mainImage.src = src;
          mainImage.srcset = '';
        }
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    if (mainImage && zoomModal && zoomImage) {
      mainImage.addEventListener('click', () => {
        zoomImage.src = mainImage.src;
        zoomModal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });

      zoomModal.querySelector('[data-zoom-close]')?.addEventListener('click', () => {
        zoomModal.classList.remove('is-open');
        document.body.style.overflow = '';
      });

      zoomModal.addEventListener('click', (e) => {
        if (e.target === zoomModal) {
          zoomModal.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      });
    }

    /* Hover zoom on desktop */
    if (mainImage && window.matchMedia('(min-width: 1024px)').matches) {
      const container = gallery.querySelector('.product-gallery__main');
      container?.addEventListener('mousemove', (e) => {
        const rect = container.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        mainImage.style.transformOrigin = `${x}% ${y}%`;
        mainImage.style.transform = 'scale(1.5)';
      });
      container?.addEventListener('mouseleave', () => {
        mainImage.style.transform = 'scale(1)';
      });
    }
  }

  /* Sticky add to cart */
  function initStickyAtc() {
    const sticky = document.querySelector(selectors.stickyAtc);
    const form = document.querySelector(selectors.productForm);
    if (!sticky || !form) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      },
      { threshold: 0, rootMargin: '0px 0px -80px 0px' }
    );
    observer.observe(form);
  }

  /* Quantity selector */
  function initQuantity() {
    document.querySelectorAll('.quantity-selector').forEach((wrapper) => {
      const input = wrapper.querySelector(selectors.quantityInput);
      const minus = wrapper.querySelector(selectors.quantityMinus);
      const plus = wrapper.querySelector(selectors.quantityPlus);
      if (!input) return;

      minus?.addEventListener('click', () => {
        const val = parseInt(input.value, 10) || 1;
        if (val > 1) input.value = val - 1;
      });
      plus?.addEventListener('click', () => {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });
  }

  /* Product tabs */
  function initProductTabs() {
    document.querySelectorAll(selectors.productTabBtn).forEach((btn) => {
      btn.addEventListener('click', () => {
        const tabId = btn.dataset.productTab;
        const container = btn.closest(selectors.productTabs);
        container?.querySelectorAll(selectors.productTabBtn).forEach((b) => b.classList.remove('is-active'));
        container?.querySelectorAll(selectors.productTabPanel).forEach((p) => p.classList.remove('is-active'));
        btn.classList.add('is-active');
        container?.querySelector(`[data-product-tab-panel="${tabId}"]`)?.classList.add('is-active');
      });
    });
  }

  /* Variant selection */
  function initVariants() {
    const form = document.querySelector(selectors.productForm);
    if (!form) return;

    form.querySelectorAll(selectors.variantOption).forEach((btn) => {
      btn.addEventListener('click', () => {
        const group = btn.closest('.product-form__option-values');
        group?.querySelectorAll(selectors.variantOption).forEach((b) => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        updateVariant(form);
      });
    });
  }

  function updateVariant(form) {
    const productJson = form.querySelector('[data-product-json]');
    if (!productJson) return;

    const product = JSON.parse(productJson.textContent);
    const selectedOptions = [];

    form.querySelectorAll('.product-form__option').forEach((optionEl) => {
      const selected = optionEl.querySelector(`${selectors.variantOption}.is-selected`);
      if (selected) selectedOptions.push(selected.dataset.value);
    });

    const variant = product.variants.find((v) =>
      v.options.every((opt, i) => opt === selectedOptions[i])
    );

    if (!variant) return;

    const idInput = form.querySelector('[name="id"]');
    if (idInput) idInput.value = variant.id;

    const priceEl = document.querySelector('[data-product-price]');
    const compareEl = document.querySelector('[data-product-compare-price]');
    const addBtn = form.querySelector('[type="submit"]');

    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (compareEl) {
      if (variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }

    if (variant.featured_image) {
      const mainImage = document.querySelector(selectors.productMainImage);
      if (mainImage) {
        mainImage.src = variant.featured_image.src;
      }
    }
  }

  function formatMoney(cents) {
    if (window.Shopify?.formatMoney) {
      return Shopify.formatMoney(cents, window.themeSettings?.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  /* Cart */
  function initCart() {
    document.querySelectorAll(selectors.cartToggle).forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        openCartDrawer();
      });
    });

    document.querySelectorAll(selectors.cartClose).forEach((btn) => {
      btn.addEventListener('click', closeCartDrawer);
    });

    document.querySelector(selectors.cartDrawer)?.querySelector('.cart-drawer__overlay')?.addEventListener('click', closeCartDrawer);

    document.querySelectorAll(selectors.quickAddForm).forEach((form) => {
      form.addEventListener('submit', handleAddToCart);
    });

    document.querySelectorAll(selectors.productForm).forEach((form) => {
      form.addEventListener('submit', handleAddToCart);
    });
  }

  function openCartDrawer() {
    document.querySelector(selectors.cartDrawer)?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    document.querySelector(selectors.cartDrawer)?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  async function handleAddToCart(e) {
    e.preventDefault();
    const form = e.target;
    const submitBtn = form.querySelector('[type="submit"]');
    const originalText = submitBtn?.textContent;

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<span class="spinner"></span>';
    }

    try {
      const formData = new FormData(form);
      const response = await fetch(window.themeSettings.routes.cartAdd + '.js', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) throw new Error('Add to cart failed');

      await refreshCart();
      if (window.themeSettings.cartType === 'drawer') {
        openCartDrawer();
      }
    } catch (err) {
      console.error(err);
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
      }
    }
  }

  async function refreshCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      updateCartUI(cart);
    } catch (err) {
      console.error(err);
    }
  }

  function updateCartUI(cart) {
    document.querySelectorAll(selectors.cartCount).forEach((el) => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });

    const subtotalEl = document.querySelector(selectors.cartSubtotal);
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    const itemsEl = document.querySelector(selectors.cartItems);
    if (!itemsEl) return;

    if (cart.items.length === 0) {
      itemsEl.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty</p><a href="/collections/all" class="btn btn--secondary mt-2">Continue Shopping</a></div>';
      return;
    }

    itemsEl.innerHTML = cart.items.map((item) => `
      <div class="cart-drawer__item">
        <img class="cart-drawer__item-image" src="${item.image ? item.image.replace(/(\.[^.]+)$/, '_120x$1') : ''}" alt="${item.title}" width="80" height="80" loading="lazy">
        <div class="cart-drawer__item-details">
          <p class="cart-drawer__item-title">${item.product_title}</p>
          ${item.variant_title !== 'Default Title' ? `<p class="cart-drawer__item-variant">${item.variant_title}</p>` : ''}
          <p class="cart-drawer__item-price">${formatMoney(item.final_line_price)} · Qty ${item.quantity}</p>
        </div>
      </div>
    `).join('');
  }

  /* Collection sort */
  function initCollectionSort() {
    const sortSelect = document.querySelector(selectors.collectionSort);
    if (!sortSelect) return;

    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* Init */
  document.addEventListener('DOMContentLoaded', () => {
    initMobileMenu();
    initFaq();
    initProductGallery();
    initStickyAtc();
    initQuantity();
    initProductTabs();
    initVariants();
    initCart();
    initCollectionSort();
    refreshCart();
  });
})();
